import { render, staticRenderFns } from "./PatientAllergiesV1.vue?vue&type=template&id=d0ad205c&"
import script from "./PatientAllergiesV1.vue?vue&type=script&lang=js&"
export * from "./PatientAllergiesV1.vue?vue&type=script&lang=js&"
import style0 from "./PatientAllergiesV1.vue?vue&type=style&index=0&id=d0ad205c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports